module.exports = __webpack_public_path__ + "static/media/man2.82feacc1.jpg";